module.exports = __webpack_public_path__ + "static/media/Hawk238_2c.67b208d3.svg";